<template>
  <button :disabled="loading" class="flex items-center">

    <span v-if="loading" :style="style" class="spinner-border spinner-border-sm" role="status" style="width: 1.5rem; height: 1.5rem;"
          aria-hidden="true"></span>

    <slot v-else/>
  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    style: {
      type: String,
      default: null,
    },
  },
}
</script>
